<script setup>
import { onMounted } from "vue";
import AOS from "./assets/vendor/aos/aos.js";
import GLightbox from "./assets/vendor/glightbox/js/glightbox.min.js";


onMounted(() => {
  AOS.init({
    duration: 900,
    easing: "ease-in-out",
    once: true,
    mirror: false,
  });

  GLightbox({ selector: ".glightbox" });
});
</script>

<template>
  <!-- <NavigationBar /> -->

  <router-view v-slot="{ Component }">
    <transition name="fade" mode="out-in">
      <component :is="Component" />
    </transition>
  </router-view>

  <!-- <Footer /> -->
</template>

